import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import type { WorkflowDecisionOutDto } from 'shared/domain/workflow/types';
import { broadcastCreatedDecision } from 'serviceWorker/broadcasts/workflow/one';
import { broadcastDecisionError } from 'serviceWorker/broadcasts/workflow/error';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { neverReached } from 'shared/utils/neverReached';

export function broadcastDecisionResponse(
  request: HttpRequestEntity,
  response: WorkflowDecisionOutDto | { error: unknown }
): void {
  if ('error' in response && response.error) {
    return broadcastDecisionError(response.error, request.data.uniqueId, chooseErrorMessage(response.error));
  }

  switch (request.method) {
    case 'POST':
      return broadcastCreatedDecision(
        response as WorkflowDecisionOutDto,
        request.data.uniqueId
      );
    case 'PUT':
    case 'DELETE':
    case 'GET':
      return broadcastDecisionError(
        new Error(`${request.method} method not supported for decision`),
        request.data.uniqueId
      );
    default:
      neverReached(request.method);
  }
}
